(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1855,6603],{

/***/ 7573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);



var server = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
  baseURL: "https://mu7.ejjadh.info"
});
server.interceptors.response.use(function (response) {
  return response;
}, /*#__PURE__*/function () {
  var _ref = (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
    var _error$response;

    var config;
    return _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = error.config;

            if (config) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.reject(error));

          case 3:
            config.__retryCount = config.__retryCount || 0;

            if (!(((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 429 && config.__retryCount < 3)) {
              _context.next = 10;
              break;
            }

            config.__retryCount++;
            console.log("429 received. Retry ".concat(config.__retryCount, "/3 for ").concat(config.url));
            _context.next = 9;
            return new Promise(function (r) {
              return setTimeout(r, 15000);
            });

          case 9:
            return _context.abrupt("return", server(config));

          case 10:
            return _context.abrupt("return", Promise.reject(error));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
/* harmony default export */ __webpack_exports__["Z"] = (server);

/***/ }),

/***/ 1855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Layout_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3108);
/* harmony import */ var _Layout_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Layout_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_api_server__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7573);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5893);










var WhatsAppIcon = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return __webpack_require__.e(/* import() */ 8951).then(__webpack_require__.bind(__webpack_require__, 8951));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
      className: (_Layout_module_scss__WEBPACK_IMPORTED_MODULE_6___default().whatsappPlaceholder)
    });
  },
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8951)];
    }
  }
});
function Layout(_ref) {
  var _data$socials3, _data$socials3$whatsA;

  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      data = _useState[0],
      setData = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var isMounted = true;

    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var res, _res$data;

        return _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return src_api_server__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/api/footer");

              case 3:
                res = _context.sent;

                if (isMounted) {
                  setData(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data);
                }

                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error("Failed to fetch footer data:", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
    return function () {
      isMounted = false;
    };
  }, []);

  var onWhatsAppClick = function onWhatsAppClick() {
    var _data$socials, _data$socials2;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "whatsapp_click",
      page: "https://wa.me/".concat(data === null || data === void 0 ? void 0 : (_data$socials = data.socials) === null || _data$socials === void 0 ? void 0 : _data$socials.whatsApp.split(" ").join(""))
    });
    window.open("https://wa.me/".concat(data === null || data === void 0 ? void 0 : (_data$socials2 = data.socials) === null || _data$socials2 === void 0 ? void 0 : _data$socials2.whatsApp.split(" ").join("")), "_blank");
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: (_Layout_module_scss__WEBPACK_IMPORTED_MODULE_6___default().button),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: "https://wa.me/".concat((data === null || data === void 0 ? void 0 : (_data$socials3 = data.socials) === null || _data$socials3 === void 0 ? void 0 : (_data$socials3$whatsA = _data$socials3.whatsApp) === null || _data$socials3$whatsA === void 0 ? void 0 : _data$socials3$whatsA.split(" ").join("")) || ""),
        rel: "noreferrer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
          target: "_blank",
          "aria-label": "Whatsapp",
          onClick: function onClick(e) {
            e.preventDefault();
            onWhatsAppClick();
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(WhatsAppIcon, {})
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("main", {
      children: children
    })]
  });
}

/***/ }),

/***/ 3108:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Layout_button__cOvhT"};

/***/ })

}]);